import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";
import Button from "../../../../components/Button";

export const Policy = styled.p`
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  line-height: 1.5;
`;

export const StaticInstrument = styled.span`
  color: var(--color-text-default);
  font-size: var(--text-md);
  font-weight: 700;
`;

export const ReplacementNote = styled.p`
  margin: 0;
  color: var(--color-warning);
  font-size: var(--text-sm);
`;

export const OverrideList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const OverrideRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
  padding: ${SPACING.sm}px 0;
  border-bottom: 1px solid var(--color-card-border);
  color: var(--color-text-default);
  font-size: var(--text-sm);
`;

export const DeleteButton = styled(Button)`
  flex-shrink: 0;
`;

export const EmptyList = styled.p`
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
`;
